import { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import JournalsList from "../journals/JournalsList";
import SliderComp from "../../components/VideoPlayer/SliderComp";

import {
  getBibleResourceKeyAction,
  getChapterJournalsAction,
  getChapterVideosAction,
} from "../../store/Bible/BibleAction";

import { FaPlay } from "react-icons/fa";
import { LuVideo } from "react-icons/lu";
import { IoClose } from "react-icons/io5";
import { FaPause } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import { FaChevronUp } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { MdClose, MdSkipPrevious } from "react-icons/md";
import { CgPlayTrackNext } from "react-icons/cg";
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import personSpeakingIcon from "../../assets/icons/personSpeaking.svg";
import { useAuth0 } from "@auth0/auth0-react";

const AudioVideoCompModel = ({
  hideVideo = false,
  hideAudio = false,
  isTextAvailable,
  isAudioAvailable,
  isVideoAvailable,
  versionDetails,
  bookChapterAudioDetails,
  bookChapterAudioDetailsLoading,
  bookChapterVideoDetails,
  bookChapterVideoDetailsLoading,
  bibleParallelMode,
  verseDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { bookId, chapterNo } = useParams();
  const { isAuthenticated } = useAuth0();

  const { currentLanguageTitles } = useSelector(
    (state) => state.languageReducer.data
  );


  const { bibleParallelMode: globalParallelMode } = useSelector(
    (state) => state.bible
  );

  const audioPlayerRef = useRef(null);
  const reactPlayerRef = useRef(null);

  const [isVideoCompActive, setIsVideoCompActive] = useState(false);
  const [bibleResourceKey, setBibleResourceKey] = useState("");
  const [isAudioCompActive, setIsAudioCompActive] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [audioDuration, setAudioDuration] = useState(0);
  const [currentAudioProgress, setCurrentAudioProgress] = useState(0);
  const [showList, setShowList] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeSpeed, setActiveSpeed] = useState(1);
  const [selectedList, setSelectedList] = useState(0);
  const [twgVideos, setTwgVideos] = useState([]);
  const [twgVideosLoading, setTwgVideosLoading] = useState(false);
  const [chapterJournals, setChapterJournals] = useState([]);
  const [chapterJournalsLoading, setChapterJournalsLoading] = useState(false);

  useEffect(() => {
    if (versionDetails?.abbr) {
      setActiveTab(0);
    }
  }, [versionDetails]);

  const [videoTabs, setVideoTabs] = useState([]);

  useEffect(() => {
    const tabs = [];
    if (bookChapterVideoDetails?.length > 0) {
      tabs.push({ key: "videos_lbl", label: "Videos" });
    }
    if (twgVideos?.length > 0) {
      tabs.push({ key: "twg_content_lbl", label: "TWG Content" });
    }
    if (chapterJournals?.length > 0) {
      tabs.push({ key: "journals_lbl", label: "Journals" });
    }

    setVideoTabs(tabs);
  }, [bookChapterVideoDetails, twgVideos, chapterJournals]);


  const fetchBibleResourceKey = () => {
    dispatch(
      getBibleResourceKeyAction({
        callback: (response) => {
          setBibleResourceKey(response?.data?.[0]?.key);
        },
      })
    );
  };

  const fetchTWGContent = () => {
    setTwgVideosLoading(true);
    dispatch(
      getChapterVideosAction({
        apiPayloadRequest: {
          languageid: versionDetails?.language_id,
          bookid: bookId,
          chapterid: chapterNo,
        },
        callback: (response) => {
          setTwgVideos(response?.data);
          setTwgVideosLoading(false);
        },
      })
    );
  };

  const fetchChapterJournals = () => {
    setChapterJournalsLoading(true);
    dispatch(
      getChapterJournalsAction({
        apiPayloadRequest: {
          languageid: versionDetails?.language_id,
          bookid: bookId,
          chapterid: chapterNo,
        },
        callback: (response) => {
          setChapterJournals(response?.data);
          setChapterJournalsLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    fetchBibleResourceKey();
  }, []);

  useEffect(() => {
    if (
      versionDetails?.iso &&
      versionDetails?.abbr &&
      bookId &&
      chapterNo &&
      isAuthenticated 
    ) {
      fetchTWGContent();
      fetchChapterJournals();
    }
  }, [
    versionDetails?.iso,
    versionDetails?.abbr,
    bookId,
    chapterNo,
    isAuthenticated,
  ]);
  useEffect(() => {
   
      fetchTWGContent();
      // fetchChapterJournals();
    }
  , [ ]);
  return (
    !bookChapterAudioDetailsLoading && (
      <>
        {(isTextAvailable || (isAudioAvailable && isVideoAvailable)) && (
          <div className="flex w-full flex-col md:relative">
            <div className="flex gap-3">
              {!hideVideo &&
                (bookChapterVideoDetails?.length > 0 ||
                  twgVideos?.length > 0 ||
                  chapterJournals?.length > 0) && (
                  <LuVideo
                    className="cursor-pointer text-4xl text-yellowish"
                    onClick={() => {
                      setIsVideoCompActive(true);
                      setIsAudioCompActive(false);
                    }}
                  />
                )}
              {!hideAudio && bookChapterAudioDetails?.length > 0 && (
                <HiOutlineSpeakerWave
                  className="cursor-pointer text-3xl text-white/80 text-yellowish"
                  onClick={() => setIsAudioCompActive((prev) => !prev)}
                />
              )}
            </div>
            {isVideoCompActive && (
              <div
                className={`absolute -left-[15vw] top-20 z-50 h-[60vh] w-[90vw] overflow-hidden rounded-3xl rounded-ss-none bg-blackishV2/95 md:-left-32 md:top-12 md:w-[700px] ${
                  bibleParallelMode ? "-translate-x-[65%]" : "translate-x-[15%]"
                }`}
              >
                <div className="custom-scrollbar grid h-full w-full grid-cols-12 overflow-y-auto bg-blackishV2/95 p-4 backdrop-blur-2xl md:p-10">
                  <div className="col-span-10">
                    <div className="flex flex-wrap gap-2 border-b border-greyish pb-4 md:gap-4">
                      {videoTabs?.map((tab, index) => (
                        <span
                          key={`video-tabitem${index}`}
                          className={`rounded-full border ${
                            activeTab === index
                              ? "border-yellowish text-yellowish"
                              : "border-greyish text-greyish"
                          } cursor-pointer px-5 py-1`}
                          onClick={() => setActiveTab(index)}
                        >
                          {currentLanguageTitles?.[0]?.bible?.[tab?.key] ??
                            tab?.label}
                        </span>
                      ))}
                    </div>
                    {videoTabs?.map((tab, index) => {
                      return activeTab === index &&
                        tab.key === "videos_lbl" &&
                        bookChapterVideoDetails?.length > 0 ? (
                        <div className="py-5">
                          {bookChapterVideoDetails?.map((item, index) => {
                            return (
                              <div
                                className="cursor-pointer border-b border-greyish py-5"
                                key={`chapter-video${index}`}
                                onClick={() => {
                                  navigate("/video-player", {
                                    state: {
                                      url: `${item?.path}?v=4&key=${bibleResourceKey}`,
                                      bible: true,
                                      title:
                                        `${item?.book_name} ${item?.chapter_start}:${item?.verse_start}` +
                                        (item?.chapter_end
                                          ? `- ${item?.chapter_end}:${item?.verse_end}`
                                          : item?.verse_end &&
                                            `- ${item?.chapter_start}:${item?.verse_end}`),
                                      _id: item?.book_id,
                                      image: item?.thumbnail,
                                    },
                                  });
                                }}
                              >
                                <div
                                  className="flex aspect-[16/9] h-44 cursor-pointer items-center justify-center rounded-md bg-cover px-5"
                                  style={{
                                    backgroundImage: `url(${item?.thumbnail})`,
                                  }}
                                >
                                  <FaPlay className="z-20 text-3xl" />
                                </div>
                                <h3 className="py-2 text-xl font-semibold">
                                  {item?.book_name} {item?.chapter_start}:
                                  {item?.verse_start}{" "}
                                  {item?.chapter_end
                                    ? `- ${item?.chapter_end}:${item?.verse_end}`
                                    : item?.verse_end &&
                                      `- ${item?.chapter_start}:${item?.verse_end}`}
                                </h3>
                              </div>
                            );
                          })}
                        </div>
                      ) : activeTab === index &&
                        tab.key === "twg_content_lbl" ? (
                        <div className="w-full py-5">
                          {twgVideosLoading ? (
                            <div className="flex w-full flex-col justify-center gap-4">
                              <div className="grid w-full grid-cols-12 gap-5">
                                <div className="col-span-3 h-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                <div className="col-span-9 flex flex-col gap-2">
                                  <div className="h-6 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                  <div className="h-16 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                </div>
                              </div>
                              <div className="grid w-full grid-cols-12 gap-5">
                                <div className="col-span-3 h-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                <div className="col-span-9 flex flex-col gap-2">
                                  <div className="h-6 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                  <div className="h-16 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            twgVideos?.map((item, index) => {
                              const thumbnail = item?.tumbnailurls?.find(
                                (d) => d?.type_of_url === "1"
                              );
                              const urls = item?.urls?.find(
                                (d) => d?.type_of_url === "1"
                              );
                              return (
                                <div
                                  className="grid w-full grid-cols-12 items-center gap-5 overflow-visible border-b border-greyish py-5"
                                  key={`twg-video${index}`}
                                >
                                  <div
                                    className="col-span-12 flex aspect-video cursor-pointer items-center justify-center rounded-2xl bg-cover bg-top md:col-span-3 md:aspect-square"
                                    style={{
                                      backgroundImage: `url(${thumbnail?.url_link})`,
                                    }}
                                    onClick={() => {
                                      navigate("/video-player", {
                                        state: {
                                          url: urls?.url_link,
                                          title: item?.video_title,
                                          _id: item?._id,
                                          image: thumbnail?.url_link,
                                        },
                                      });
                                    }}
                                  >
                                    <FaPlay className="z-20 text-3xl" />
                                  </div>
                                  <div className="col-span-12 md:col-span-9">
                                    <h3 className="pb-2 text-xl font-semibold">
                                      {item?.video_title}
                                    </h3>
                                    <p className="line-clamp-4 overflow-hidden overflow-ellipsis text-sm text-greyish">
                                      {item?.video_description}
                                    </p>
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      ) : (
                        activeTab === index &&
                        tab.key === "journals_lbl" && (
                          <div className="h-full w-full py-5">
                            {chapterJournalsLoading ? (
                              <div className="grid grid-cols-3 gap-3">
                                <div className="aspect-square animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                                <div className="aspect-square animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                                <div className="aspect-square animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                                <div className="aspect-square animate-pulse rounded-3xl rounded-es-none bg-zinc-600"></div>
                                <div className="aspect-square animate-pulse rounded-3xl rounded-ee-none bg-zinc-600"></div>
                                <div className="aspect-square animate-pulse rounded-3xl rounded-es-none bg-zinc-600"></div>
                              </div>
                            ) : (
                              <JournalsList
                                gridItems={2}
                                data={chapterJournals}
                                chapter={true}
                              />
                            )}
                          </div>
                        )
                      );
                    })}
                  </div>
                  <div className="col-span-2 flex justify-end">
                    <IoClose
                      className="cursor-pointer text-3xl text-yellowish"
                      onClick={() => {
                        setIsVideoCompActive(false);
                        setActiveTab(0);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {isAudioCompActive && (
              <div
                className={`absolute left-5 top-12 z-50 md:-left-[50%] md:top-3 ${
                  bibleParallelMode ? "translate-x-[65%]" : ""
                }`}
              >
                <div
                  className={`${
                    showList ? "md:w-[400px]" : "w-[300px]"
                  } relative mt-10 flex flex-col items-center rounded-[40px] bg-greyishV2 py-2`}
                >
                  <MdClose
                    className="absolute right-5 top-2 z-50 cursor-pointer text-yellowish"
                    onClick={() => setIsAudioCompActive(false)}
                  />

                  <div className="relative flex w-full flex-col items-center">
                    {showList && (
                      <div
                        className="absolute -top-4 cursor-pointer rounded-t-[3rem] bg-greyishV2 p-1 text-yellowish"
                        onClick={() => setShowList(false)}
                      >
                        <FaChevronUp />
                      </div>
                    )}
                    <div className="flex items-center gap-10 pt-2 text-3xl text-yellowish">
                      <MdSkipPrevious
                        onClick={() => {
                          if (bookChapterAudioDetails?.length > 1) {
                            setSelectedList(
                              selectedList === 0
                                ? bookChapterAudioDetails?.length - 1
                                : selectedList - 1
                            );
                          }
                        }}
                      />{" "}
                      <button
                        onClick={() => {
                          setIsAudioPlaying((prev) => !prev);
                          if (isAudioPlaying) {
                            if (
                              !bookChapterAudioDetails?.[
                                selectedList
                              ]?.path?.includes("m3u8")
                            ) {
                              audioPlayerRef.current.pause();
                            }
                          } else {
                            if (
                              !bookChapterAudioDetails?.[
                                selectedList
                              ]?.path?.includes("m3u8")
                            ) {
                              audioPlayerRef.current.play();
                            }
                          }
                        }}
                      >
                        {isAudioPlaying ? <FaPause /> : <FaPlay />}
                      </button>{" "}
                      <CgPlayTrackNext
                        onClick={() => {
                          if (bookChapterAudioDetails?.length > 1) {
                            setSelectedList(
                              selectedList ===
                                bookChapterAudioDetails?.length - 1
                                ? 0
                                : selectedList + 1
                            );
                          }
                        }}
                      />
                    </div>
                    {bookChapterAudioDetails?.[selectedList]?.path?.includes(
                      "m3u8"
                    ) ? (
                      <ReactPlayer
                        url={`${bookChapterAudioDetails?.[selectedList]?.path}?key=a06351bd-4cae-40e7-90ec-ffdd13506987&v=4`}
                        playing={isAudioPlaying}
                        controls={false}
                        ref={reactPlayerRef}
                        width="0"
                        height="0"
                        onDuration={(duration) => setAudioDuration(duration)}
                        onProgress={({ played }) =>
                          setCurrentAudioProgress(played)
                        }
                        playbackRate={activeSpeed}
                        onPause={() => setIsAudioPlaying(false)}
                      />
                    ) : (
                      <audio
                        src={bookChapterAudioDetails?.[selectedList]?.path}
                        ref={audioPlayerRef}
                        onLoadedMetadata={() => {
                          if (audioPlayerRef.current) {
                            setAudioDuration(audioPlayerRef.current.duration);
                            audioPlayerRef.current.playbackRate = activeSpeed;
                          }
                        }}
                        onTimeUpdate={() => {
                          setCurrentAudioProgress(
                            audioPlayerRef.current.currentTime / audioDuration
                          );
                        }}
                        onPause={() => setIsAudioPlaying(false)}
                      ></audio>
                    )}

                    <SliderComp
                      handleChange={(event) => {
                        if (
                          bookChapterAudioDetails?.[
                            selectedList
                          ]?.path?.includes("m3u8")
                        ) {
                          if (reactPlayerRef.current) {
                            const playedSeconds = parseFloat(
                              (
                                audioDuration *
                                (event.target.value / 100)
                              ).toFixed(2)
                            );
                            reactPlayerRef.current.seekTo(
                              playedSeconds,
                              "seconds"
                            );
                          }
                        } else {
                          if (audioPlayerRef?.current) {
                            const playedSeconds = parseFloat(
                              (
                                audioDuration *
                                (event.target.value / 100)
                              ).toFixed(2)
                            );
                            audioPlayerRef.current.currentTime = playedSeconds;
                          }
                        }
                        setCurrentAudioProgress(
                          parseFloat(event.target.value / 100)
                        );
                      }}
                      value={currentAudioProgress * 100}
                      step={1}
                      className="my-3 w-10/12"
                    />
                    {!showList && (
                      <div
                        className="absolute -bottom-4 cursor-pointer rounded-full bg-greyishV2 text-yellowish"
                        onClick={() => setShowList(true)}
                      >
                        <FaChevronDown />
                      </div>
                    )}
                  </div>

                  {showList && (
                    <div className="w-full px-6 md:px-10">
                      <div className="flex w-full items-center justify-center gap-2 py-2">
                        {[0.75, 1, 1.25, 1.5, 1.75, 2]?.map((item, index) => (
                          <p
                            key={`audio-speed${index}`}
                            className={`cursor-pointer p-1 ${
                              activeSpeed === item
                                ? "cursor-pointer rounded-md bg-yellowish px-2 font-semibold text-blackish"
                                : "text-sm text-greyish"
                            }`}
                            onClick={() => {
                              setActiveSpeed(item);
                              if (
                                !bookChapterAudioDetails?.[
                                  selectedList
                                ]?.path?.includes("m3u8")
                              ) {
                                if (audioPlayerRef.current) {
                                  audioPlayerRef.current.playbackRate = item;
                                }
                              }
                            }}
                          >
                            {item}x
                          </p>
                        ))}
                      </div>
                      <div className="custom-scrollbar mx-auto my-2 flex max-h-[200px] w-full flex-col gap-2 overflow-y-auto rounded-3xl bg-greyishV5 p-5">
                        {bookChapterAudioDetails?.map((item, index) => {
                          return (
                            <div
                              className={`flex cursor-pointer items-center justify-between gap-3 rounded-md px-2 py-0.5 ${
                                selectedList === index
                                  ? "scale-x-10 bg-yellowish px-2 text-blackish"
                                  : "text-greyish"
                              }`}
                              key={index}
                              onClick={() => {
                                if (
                                  bookChapterAudioDetails?.[
                                    selectedList
                                  ]?.path?.includes("m3u8")
                                ) {
                                  if (reactPlayerRef.current)
                                    reactPlayerRef.current.pause();
                                } else {
                                  if (audioPlayerRef.current)
                                    audioPlayerRef.current.pause();
                                }
                                setSelectedList(index);
                                setCurrentAudioProgress(0);
                                setIsAudioPlaying(false);
                              }}
                            >
                              <div className="flex items-center gap-2">
                                {selectedList === index && (
                                  <img
                                    src={personSpeakingIcon}
                                    alt=""
                                    className="w-[18px] object-contain"
                                  />
                                )}
                                <div className="flex flex-col">
                                  <p
                                    className={`text-sm ${
                                      selectedList === index
                                        ? "font-semibold"
                                        : ""
                                    }`}
                                  >
                                    {verseDetails?.name}
                                  </p>
                                  <span
                                    className={`text-xs text-black/70 ${
                                      selectedList === index
                                        ? "font-semibold"
                                        : ""
                                    }`}
                                  >
                                    {item?.type === "audio_drama"
                                      ? "Audio Drama"
                                      : "Audio"}
                                  </span>
                                </div>
                              </div>

                              {selectedList === index && (
                                <FaCheck className="text-xl" />
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {!isTextAvailable && !isVideoAvailable && isAudioAvailable && (
          <div className="relative flex flex-col">
            <div className="relative mt-10 flex w-[400px] flex-col items-center rounded-[40px] bg-greyishV2 py-2">
              <div className="relative flex w-full flex-col items-center">
                <div className="flex items-center gap-10 pt-2 text-3xl text-yellowish">
                  <MdSkipPrevious
                    onClick={() => {
                      if (bookChapterAudioDetails?.length > 1) {
                        setSelectedList(
                          selectedList === 0
                            ? bookChapterAudioDetails?.length - 1
                            : selectedList - 1
                        );
                      }
                    }}
                  />{" "}
                  <button
                    onClick={() => {
                      setIsAudioPlaying((prev) => !prev);
                      if (isAudioPlaying) {
                        if (
                          !bookChapterAudioDetails?.[
                            selectedList
                          ]?.path?.includes("m3u8")
                        ) {
                          audioPlayerRef.current.pause();
                        }
                      } else {
                        if (
                          !bookChapterAudioDetails?.[
                            selectedList
                          ]?.path?.includes("m3u8")
                        ) {
                          audioPlayerRef.current.play();
                        }
                      }
                    }}
                  >
                    {isAudioPlaying ? <FaPause /> : <FaPlay />}
                  </button>{" "}
                  <CgPlayTrackNext
                    onClick={() => {
                      if (bookChapterAudioDetails?.length > 1) {
                        setSelectedList(
                          selectedList === bookChapterAudioDetails?.length - 1
                            ? 0
                            : selectedList + 1
                        );
                      }
                    }}
                  />
                </div>
                {bookChapterAudioDetails?.[selectedList]?.path?.includes(
                  "m3u8"
                ) ? (
                  <ReactPlayer
                    url={`${bookChapterAudioDetails?.[selectedList]?.path}?key=a06351bd-4cae-40e7-90ec-ffdd13506987&v=4`}
                    playing={isAudioPlaying}
                    controls={false}
                    ref={reactPlayerRef}
                    width="0"
                    height="0"
                    onDuration={(duration) => setAudioDuration(duration)}
                    onProgress={({ played }) => setCurrentAudioProgress(played)}
                    playbackRate={activeSpeed}
                    onPause={() => setIsAudioPlaying(false)}
                  />
                ) : (
                  <audio
                    src={bookChapterAudioDetails?.[selectedList]?.path}
                    ref={audioPlayerRef}
                    onLoadedMetadata={() => {
                      if (audioPlayerRef.current) {
                        setAudioDuration(audioPlayerRef.current.duration);
                        audioPlayerRef.current.playbackRate = activeSpeed;
                      }
                    }}
                    onTimeUpdate={() => {
                      setCurrentAudioProgress(
                        audioPlayerRef.current.currentTime / audioDuration
                      );
                    }}
                    onPause={() => setIsAudioPlaying(false)}
                  ></audio>
                )}

                <SliderComp
                  handleChange={(event) => {
                    if (
                      bookChapterAudioDetails?.[selectedList]?.path?.includes(
                        "m3u8"
                      )
                    ) {
                      if (reactPlayerRef?.current) {
                        const playedSeconds = parseFloat(
                          (audioDuration * (event.target.value / 100)).toFixed(
                            2
                          )
                        );
                        reactPlayerRef.current.seekTo(playedSeconds, "seconds");
                      }
                    } else {
                      if (audioPlayerRef?.current) {
                        const playedSeconds = parseFloat(
                          (audioDuration * (event.target.value / 100)).toFixed(
                            2
                          )
                        );
                        audioPlayerRef.current.currentTime = playedSeconds;
                      }
                    }
                    setCurrentAudioProgress(
                      parseFloat(event.target.value / 100)
                    );
                  }}
                  value={currentAudioProgress * 100}
                  step={1}
                  className="my-3 w-10/12"
                />
              </div>

              <div className="w-full px-10">
                <div className="flex w-full items-center justify-center gap-2 py-2">
                  {[0.75, 1, 1.25, 1.5, 1.75, 2]?.map((item, index) => (
                    <p
                      key={`audio-speed${index}`}
                      className={`cursor-pointer p-1 ${
                        activeSpeed === item
                          ? "cursor-pointer rounded-md bg-yellowish px-2 font-semibold text-blackish"
                          : "text-sm text-greyish"
                      }`}
                      onClick={() => {
                        setActiveSpeed(item);
                        if (
                          bookChapterAudioDetails?.[
                            selectedList
                          ]?.path?.includes("m3u8")
                        ) {
                          if (reactPlayerRef.current) {
                            reactPlayerRef.current.playbackRate = item; // Update playback speed
                          }
                        } else {
                          if (audioPlayerRef.current) {
                            audioPlayerRef.current.playbackRate = item; // Update playback speed
                          }
                        }
                      }}
                    >
                      {item}x
                    </p>
                  ))}
                </div>
                <div className="custom-scrollbar mx-auto my-2 flex max-h-[200px] w-full flex-col gap-2 overflow-y-auto rounded-3xl bg-greyishV5 p-5">
                  {bookChapterAudioDetails?.map((item, index) => {
                    return (
                      <div
                        className={`flex cursor-pointer items-center justify-between gap-3 rounded-md px-2 py-0.5 ${
                          selectedList === index
                            ? "scale-x-10 bg-yellowish px-2 text-blackish"
                            : "text-greyish"
                        }`}
                        key={index}
                        onClick={() => {
                          if (
                            bookChapterAudioDetails?.[
                              selectedList
                            ]?.path?.includes("m3u8")
                          ) {
                            if (reactPlayerRef.current)
                              reactPlayerRef.current.pause();
                          } else {
                            if (audioPlayerRef.current)
                              audioPlayerRef.current.pause();
                          }
                          setSelectedList(index);
                          setCurrentAudioProgress(0);
                          setIsAudioPlaying(false);
                        }}
                      >
                        <div className="flex items-center gap-2">
                          {selectedList === index && (
                            <img
                              src={personSpeakingIcon}
                              alt=""
                              className="w-[18px] object-contain"
                            />
                          )}
                          <div className="flex flex-col">
                            <p
                              className={`text-sm ${selectedList === index ? "font-semibold" : ""}`}
                            >
                              {verseDetails?.vname}
                            </p>
                            <span
                              className={`text-xs text-black/70 ${
                                selectedList === index ? "font-semibold" : ""
                              }`}
                            >
                              {item?.filesetDetail?.type === "audio_drama"
                                ? "Audio Drama"
                                : "Audio"}
                            </span>
                          </div>
                        </div>

                        {selectedList === index && (
                          <FaCheck className="text-xl" />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        {!isTextAvailable && !isAudioAvailable && isVideoAvailable && (
          <div
            className={`h-[60vh] overflow-hidden rounded-3xl rounded-ss-none bg-blackishV2/95 ${
              globalParallelMode ? "w-full" : "w-full"
            }`}
          >
            <div className="custom-scrollbar grid h-full w-full grid-cols-12 overflow-y-auto bg-blackishV2/95 p-10 backdrop-blur-2xl">
              <div className="col-span-10">
                <div className="flex flex-wrap gap-4 border-b border-greyish pb-4">
                  {videoTabs?.map((tab, index) => (
                    <span
                      key={`video-tabitem${index}`}
                      className={`rounded-full border ${
                        activeTab === index
                          ? "border-yellowish text-yellowish"
                          : "border-greyish text-greyish"
                      } cursor-pointer px-5 py-1`}
                      onClick={() => setActiveTab(index)}
                    >
                      {tab}
                    </span>
                  ))}
                </div>
                {videoTabs?.map((tab, index) => {
                  return activeTab === index &&
                    tab === "Videos" &&
                    bookChapterVideoDetails?.length > 0 ? (
                    <div className="py-5">
                      {bookChapterVideoDetails?.map((item, index) => {
                        return (
                          <div
                            className="cursor-pointer border-b border-greyish py-5"
                            key={`chapter-video${index}`}
                            onClick={() => {
                              navigate("/video-player", {
                                state: {
                                  url: `${item?.path}?v=4&key=${bibleResourceKey}`,
                                  bible: true,
                                  title:
                                    `${item?.book_name} ${item?.chapter_start}:${item?.verse_start}` +
                                    (item?.chapter_end
                                      ? `- ${item?.chapter_end}:${item?.verse_end}`
                                      : item?.verse_end &&
                                        `- ${item?.chapter_start}:${item?.verse_end}`),
                                  _id: item?.book_id,
                                  image: item?.thumbnail,
                                },
                              });
                            }}
                          >
                            <div
                              className="flex aspect-[16/9] h-44 cursor-pointer items-center justify-center rounded-md bg-cover px-5"
                              style={{
                                backgroundImage: `url(${item?.thumbnail})`,
                              }}
                            >
                              <FaPlay className="z-20 text-3xl" />
                            </div>
                            <h3 className="py-2 text-xl font-semibold">
                              {item?.book_name} {item?.chapter_start}:
                              {item?.verse_start}{" "}
                              {item?.chapter_end
                                ? `- ${item?.chapter_end}:${item?.verse_end}`
                                : item?.verse_end &&
                                  `- ${item?.chapter_start}:${item?.verse_end}`}
                            </h3>
                          </div>
                        );
                      })}
                    </div>
                  ) : activeTab === index && tab === "TWG Content" ? (
                    <div className="w-full py-5">
                      {twgVideosLoading ? (
                        <div className="flex w-full flex-col justify-center gap-4">
                          <div className="grid w-full grid-cols-12 gap-5">
                            <div className="col-span-3 h-full animate-pulse rounded-2xl bg-zinc-600"></div>
                            <div className="col-span-9 flex flex-col gap-2">
                              <div className="h-6 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                              <div className="h-16 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                            </div>
                          </div>
                          <div className="grid w-full grid-cols-12 gap-5">
                            <div className="col-span-3 h-full animate-pulse rounded-2xl bg-zinc-600"></div>
                            <div className="col-span-9 flex flex-col gap-2">
                              <div className="h-6 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                              <div className="h-16 w-full animate-pulse rounded-2xl bg-zinc-600"></div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        twgVideos?.map((item, index) => {
                          const thumbnail = item?.tumbnailurls?.find(
                            (d) => d?.type_of_url === "1"
                          );
                          const urls = item?.urls?.find(
                            (d) => d?.type_of_url === "1"
                          );
                          return (
                            <div
                              className="grid w-full grid-cols-12 items-center gap-5 overflow-visible border-b border-greyish py-5"
                              key={`twg-video${index}`}
                            >
                              <div
                                className="col-span-3 flex aspect-square cursor-pointer items-center justify-center rounded-2xl bg-cover bg-top"
                                style={{
                                  backgroundImage: `url(${thumbnail?.url_link})`,
                                }}
                                onClick={() => {
                                  navigate("/video-player", {
                                    state: {
                                      url: urls?.url_link,
                                      title: item?.video_title,
                                      _id: item?._id,
                                      image: thumbnail?.url_link,
                                    },
                                  });
                                }}
                              >
                                <FaPlay className="z-20 text-3xl" />
                              </div>
                              <div className="col-span-9">
                                <h3 className="pb-2 text-xl font-semibold">
                                  {item?.video_title}
                                </h3>
                                <p className="line-clamp-4 overflow-hidden overflow-ellipsis text-sm text-greyish">
                                  {item?.video_description}
                                </p>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  ) : (
                    activeTab === index &&
                    tab === "Journals" && (
                      <div className="h-full w-full py-5">
                        {chapterJournalsLoading ? (
                          <div className="grid grid-cols-3 gap-3">
                            <div className="aspect-square animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                            <div className="aspect-square animate-pulse rounded-3xl rounded-se-none bg-zinc-600"></div>
                            <div className="aspect-square animate-pulse rounded-3xl rounded-ss-none bg-zinc-600"></div>
                            <div className="aspect-square animate-pulse rounded-3xl rounded-es-none bg-zinc-600"></div>
                            <div className="aspect-square animate-pulse rounded-3xl rounded-ee-none bg-zinc-600"></div>
                            <div className="aspect-square animate-pulse rounded-3xl rounded-es-none bg-zinc-600"></div>
                          </div>
                        ) : (
                          <JournalsList
                            gridItems={3}
                            data={chapterJournals}
                            chapter={true}
                          />
                        )}
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </>
    )
  );
};

export default AudioVideoCompModel;
